import { formatStakeholdersListToBE } from '../../formatters/stakeholdersListTransformers'

import { COUNTRY_ID } from '../../fields'
import { STAKEHOLDERS_LIST } from '../../stakeholdersFields'

export const transformValuesToBE = values => {
  return {
    [COUNTRY_ID]: values[COUNTRY_ID],
    [STAKEHOLDERS_LIST]: formatStakeholdersListToBE(values)
  }
}
